import desi from '../../img/menu/desi.jpg';
import indian_snacks from '../../img/menu/indian_snacks.jpg';
import italian from '../../img/menu/italian.jpg';
import pizza from '../../img/menu/pizza.jpg';
import plantbased from '../../img/menu/plantbased.jpg';
import south_indian from '../../img/menu/south_indian.jpg';



const MenuCover = {
  "desi-flavour": {
    cover: desi,
    heading: "DESI FLAVOUR MENUS"
  },
  "south-indian":{
    cover: south_indian,
    heading:"South indian menus"
  },
  "italian":{
    cover: italian,
    heading:"Italian Menus"
  },
  "pizza":{
    cover: pizza,
    heading:"Pizza Menus"
  },
  "indian-snacks":{
    cover: indian_snacks,
    heading:"Indain Snack Menus"
  },
  "plantbased":{
    cover: plantbased,
    heading:"Plant Based Menus"
  }
}

export default  MenuCover;